module.exports = {
	"id": "ST",
	"name": "Sao Tome and Principe",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.0263,
			"12": null,
			"13": null,
			"14": 0.0263,
			"15": null,
			"16": 0.046025,
			"17": null,
			"18": 0.0526,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": 0.046025,
			"27": null,
			"28": null,
			"29": null,
			"30": 0.01315,
			"31": 0.01315,
			"32": null,
			"33": 0.190675,
			"34": 0.059175,
			"35": null,
			"36": 0.085475,
			"37": null,
			"38": 0.019725,
			"39": 0.032875,
			"40": 0.243275,
			"41": null,
			"42": 0.032875,
			"43": 8.1267,
			"44": 0.059175,
			"45": 0.019725,
			"46": 0.019725,
			"47": 0.072325,
			"48": 0.072325,
			"49": 2.255225,
			"50": 0.11835,
			"51": 0.821875,
			"52": 0.703525,
			"53": 30.2187,
			"54": 5.1548,
			"55": 0.046025,
			"56": null,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.01315,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": 0.059175,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": 0.019725,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": 0.01315,
			"32": null,
			"33": null,
			"34": 0.269575,
			"35": 0.03945,
			"36": null,
			"37": 0.019725,
			"38": null,
			"39": null,
			"40": 0.006575,
			"41": null,
			"42": 0.019725,
			"43": 0.164375,
			"44": 0.046025,
			"45": 0.019725,
			"46": 0.032875,
			"47": 0.479975,
			"48": 0.348475,
			"49": 3.82665,
			"50": 0.0263,
			"51": null,
			"52": null,
			"3.5": null,
			"3.6": null
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": 0.01315,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": 0.0263,
			"37": 0.019725,
			"38": null,
			"39": null,
			"40": 0.348475,
			"41": 0.019725,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": null
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": null,
			"6": null,
			"7": null,
			"8": 0.0789,
			"9": 0.019725,
			"10": 1.03885,
			"3.1": null,
			"3.2": null,
			"5.1": null,
			"6.1": 0.032875,
			"7.1": null,
			"9.1": 0.335325
		},
		"ios_saf": {
			"8": 0,
			"10": 1.17300118651,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0316110246669,
			"8.1-8.4": 0.058400028622,
			"9.0-9.2": 0.0278605641132,
			"9.3": 0.425052196087
		},
		"android": {
			"3": 0,
			"4": 0.112936498708,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0141170623385,
			"4.1": 0.407378084625,
			"4.2-4.3": 1.01844521156,
			"4.4": 2.33536545543,
			"4.4.3-4.4.4": 2.35553268734
		},
		"ie": {
			"6": null,
			"7": null,
			"8": 0.51285,
			"9": 0.006575,
			"10": 0.151225,
			"11": 2.7089,
			"5.5": null
		},
		"op_mob": {
			"0": 0.282491683671,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.00784699121309
		},
		"edge": {
			"12": 0.1052,
			"13": 0.4208,
			"14": 0.80215
		},
		"ie_mob": {
			"10": 0.157357042254,
			"11": 0.640667957746
		},
		"bb": {
			"7": 0.00599375,
			"10": null
		},
		"samsung": {
			"0": 1.2878
		},
		"and_uc": {
			"0": 3.914775
		},
		"op_mini": {
			"0": 3.80596132512
		},
		"and_chr": {
			"0": 18.34385
		},
		"and_ff": {
			"0": 0.037675
		}
	},
	"total": 97.06561875
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/ST.json
 ** module id = 651
 ** module chunks = 0
 **/